import { useMemo } from 'react';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';

import Page from 'components/layouts/page/Page';
import FilterChips from 'components/shared/FilterChips';
import { FilterSection } from 'components/shared/filters/FilterSlideout';
import DesktopOnly from 'components/shared/responsiveness/DesktopOnly';
import { useTranslation } from 'context/translations';
import FilterValueBoolean from 'models/filterValues/FilterValueBoolean';
import { useInsightsStore } from 'stores/insightsStore';

import InsightsFilterBar from './filterBar/InsightsFilterBar';
import { getFiltersForSelectedGroupType } from './layout/helpers/filters';
import { useInsightsContext } from './InsightsContainer';

export default function InsightsPage() {
  const { profile } = useInsightsContext();
  const filters = useInsightsStore((state) => state.filters);
  const selectedGroupType = useInsightsStore((state) => state.selectedGroupType);
  const { translate } = useTranslation();

  const [filtersForSelectedGroupType, filterSections] = useMemo(
    () => getFiltersForSelectedGroupType(filters, selectedGroupType, profile, translate),
    [filters, selectedGroupType, profile, translate]
  );

  const chippableFilters = Object.entries(filtersForSelectedGroupType).reduce((acc, [filterKey, values]) => {
    if ((Array.isArray(values) && values.length) || (values instanceof FilterValueBoolean && values.value)) {
      return { ...acc, [filterKey]: values };
    }
    return acc;
  }, {});

  return (
    <Page>
      <StyledPageHeader>
        <InsightsFilterBar
          filterSections={filterSections as FilterSection[]}
          activeFilters={filtersForSelectedGroupType}
        />
      </StyledPageHeader>
      <Page.SubHeader>
        <DesktopOnly>
          <FilterChips filters={chippableFilters} useStore={useInsightsStore} />
        </DesktopOnly>
      </Page.SubHeader>
      <Page.Content>
        <Outlet />
      </Page.Content>
    </Page>
  );
}

const StyledPageHeader = styled(Page.Header)`
  background: none;
  border-bottom: none;
`;
